import { useNavigate } from 'react-router-dom';
import { BuilderWizard, WizardStep } from '@unwritten/builder';
import { FileText } from 'lucide-react';

export function TemplateWizard() {
  const navigate = useNavigate();

  const steps: WizardStep[] = [
    {
      id: 'basics',
      title: 'Basic Info',
      description: 'Set up template name and type',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Basic template information form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'structure',
      title: 'Template Structure',
      description: 'Define template fields and schema',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Template structure editor coming soon...</p>
        </div>
      ),
    },
    {
      id: 'validation',
      title: 'Validation',
      description: 'Set up validation rules',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Validation rules form coming soon...</p>
        </div>
      ),
    },
    {
      id: 'review',
      title: 'Review',
      description: 'Review and create template',
      render: (_data, _onChange) => (
        <div className="space-y-4">
          <p className="text-gray-600">Review screen coming soon...</p>
        </div>
      ),
    },
  ];

  const handleComplete = async (data: any) => {
    console.log('Template created:', data);
    navigate('/templates');
  };

  const handleCancel = () => {
    navigate('/templates');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center gap-3 mb-6">
        <FileText className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold">Create New Template</h1>
      </div>

      <BuilderWizard
        steps={steps}
        onComplete={handleComplete}
        onCancel={handleCancel}
        persistenceKey="template-wizard"
      />
    </div>
  );
}
